export default __webpack_public_path__ + "static/media/times-solid.68623a14.svg";